import { AxiosResponseType } from '../../types/axiosTypes';
import api from '../axios';
import { fetchAuthSession } from '@aws-amplify/core';

export const getUser = async (): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();

    const res = await api.post<AxiosResponseType>(`/user/get_user`, {
      token: idToken,
    });
    return res.data;
  } else {
    throw new Error('User Not found');
  }
};

export const editUser = async (
  userId: string,
  userData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/edit_user`, {
      token: idToken,
      userData,
      userId,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const createUser = async (
  userData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    console.log(userData);
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/create_user`, {
      token: idToken,
      userData,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const createUsersBulk = async (
  userList: any[]
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/create_users_bulk`, {
      token: idToken,
      users: userList,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const deleteUser = async (
  userId: string
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/delete_user`, {
      token: idToken,
      userId,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const getCompanyUsers = async (
  userId: string,
  updatedData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/get_company_users`, {
      token: idToken,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const getSiteUsers = async (
  userId: string,
  updatedData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/get_site_users`, {
      token: idToken,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const updateUser = async (
  userId: string,
  updatedData: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/update_user`, {
      token: idToken,
      userId,
      updatedData,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};

export const changeSelectedSite = async (
  siteId: any
): Promise<AxiosResponseType | null> => {
  const { tokens } = await fetchAuthSession();
  if (tokens) {
    const idToken = tokens.idToken?.toString();
    const res = await api.post<AxiosResponseType>(`/user/change_site`, {
      token: idToken,
      payload: siteId,
    });
    return res.data;
  } else {
    throw new Error('User not authenticated');
  }
};
